// describedBy — canonical helper for building an `aria-describedby` token list.
//
// Several components/forms hand-roll `[errorId, hintId].filter(Boolean).join(' ')`
// (see FormField). This centralizes that: pass any number of id strings (some may
// be undefined/null/empty) and get back a single space-separated token string —
// or `undefined` when there are none, so it can be spread straight onto a control
// without emitting an empty `aria-describedby=""`.
export function describedBy(...ids: Array<string | false | null | undefined>): string | undefined {
  const tokens = ids.filter((id): id is string => Boolean(id && String(id).trim()))
  return tokens.length ? tokens.join(' ') : undefined
}
